<template>
    <div ref="map"></div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import gMapLoader from "@/types";
import {v4 as uuidv4} from 'uuid';

@Options({
    name: 'GMap',
    emits: ['mapClick'],
    components: {},
    props: {
        readonly: false,
        marker: {
            type: Object,
            required: false
        },
        center: {
            type: Object,
            default: {
                lat: 41.9099533,
                lng: 12.3711917
            }
        },
        zoom: {
            type: Number,
            default: 10,
            required: false
        },
        risultati: {
            type: Array,
            default: () => []
        },
    },
})
export default class GMap extends Vue {
    center: any;
    marker!: any;
    markerClass!: any;
    mapMarker: any | null = null
    map!: any;
    zoom!: number;
    readonly!: boolean;
    timeout: null | number = null;

    updated() {
        this.setCenter();
        if (this.marker) {
            this.mapMarker.position = {lat: this.marker.lat, lng: this.marker.lng};
            this.mapMarker.setMap(this.map);
        } else {
            this.mapMarker.setMap(null);
        }
    }

    setCenter() {
        if (this.center?.lat && this.center?.lng) {
            this.map.setCenter(this.center);
        }
    }


    async mounted() {
        const maps = await gMapLoader.importLibrary("maps");
        const {AdvancedMarkerElement} = await gMapLoader.importLibrary("marker");
        this.markerClass = AdvancedMarkerElement;

        const map = this.$refs.map as HTMLElement;
        this.map = new maps.Map(map, {
            center: {lat: this.center.lat, lng: this.center.lng},
            zoom: 10,
            mapId: uuidv4()
        });

        this.map.addListener('click', async (event: any) => {
            if (!this.readonly) {
                this.$emit('mapClick', event);
                const {Geocoder} = await gMapLoader.importLibrary("geocoding");
                const geocoder = new Geocoder();
                geocoder.geocode(
                    {location: {lat: event.latLng.lat(), lng: event.latLng.lng()}}
                ).then((res: any) => {
                    this.$emit('update:risultati', res.results)
                })
            }
        })

        this.mapMarker = new this.markerClass({
            position: {
                lat: this.center.lat,
                lng: this.center.lng
            },
        });
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
